import * as React from "react";
import { theme } from "../../../theme";

interface Props {
  color?: string;
}

export const UploadIcon: React.FC<Props> = ({ color = theme.colors.text }) => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M12.002 2.66663H4.00195"
      stroke={color}
      strokeWidth="1.5"
      strokeLinecap="round"
    />
    <path
      d="M8.00195 5.33337V13.3334"
      stroke={color}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M10.6686 8.00004C10.6686 8.00004 8.7046 5.33338 8.00193 5.33337C7.2992 5.33337 5.33527 8.00004 5.33527 8.00004"
      stroke={color}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
